<template>
  <div id="app">
    <global-header></global-header>
    <main class="main">
      <router-view />
    </main>
    <global-footer></global-footer>
  </div>
</template>
<script>
import GlobalHeader from "@/components/GlobalHeader";
import GlobalFooter from "@/components/GlobalFooter";
import $ from "jquery";
export default {
  data: function () {
    return {};
  },
  components: {
    GlobalHeader,
    GlobalFooter,
  },
  methods: {
    paramTakeover: function () {
      var utm_source = this.getUrlParameter("utm_source");
      var utm_campaign = this.getUrlParameter("utm_campaign");
      if (utm_source === "" && utm_campaign === "") {
        $(".cta_link").each(function () {
          var obj = $(this);
          var link = obj.attr("href");
          obj.attr("href", link);
        });
      } else {
        var urlParam = "selected_media=" + utm_source + "_" + utm_campaign;
        $(".cta_link").each(function () {
          var obj = $(this);
          var link = obj.attr("href");
          if (link.match(".*?.*=.*")) {
            obj.attr("href", link + "&" + urlParam);
          } else {
            obj.attr("href", link + "?" + urlParam);
          }
        });
      }
    },
    getUrlParameter: function (name) {
      name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      var results = regex.exec(location.search);
      return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    },
  },
  mounted: function () {
    this.paramTakeover();
  },
};
</script>
<style lang="scss">
@import "assets/css/reset";
#app {
  font-family: "メイリオ", meiryo, "ヒラギノ角ゴ Pro W3",
    "Hiragino Kaku Gothic Pro", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}
.wf-active {
  #app {
    font-family: "Citroen", "メイリオ", meiryo, "ヒラギノ角ゴ Pro W3",
      "Hiragino Kaku Gothic Pro", Arial, sans-serif;
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.main {
  padding-left: 15px;
  padding-right: 15px;
  display: block;
}
</style>
